import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';

//Components
import EditDirectory from './EditDirectory/EditDirectory';
import FullDoctorCouponModal from './FullDoctorCouponModal';
import { deleteDoctor, loadDoctors } from '../../../actions/admin/doctor';
import { DOCTOR_UPD } from '../../../constants/admin/doctor_constants';

// import img_1 from '../../../assets/resources/Admins/Diego.jpg';

//MUI
import { Avatar, Box, Chip, Container, Fab, ListItemIcon, MenuItem, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { basicMsg, simpleConfirmDialog } from '../../../actions/swal_msg';

const AdminDirectory = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { doctors } = useSelector(state => state.doctor);

    const [activeDoctor, setActiveDoctor] = useState(DOCTOR_UPD);
    const [couponDoctor, setCouponDoctor] = useState(null);
    const [couponModal, setCouponModal] = useState(false);

    useEffect(() => {
        dispatch(loadDoctors());
    }, []);

    useEffect(() => {
        if (location.state?.couponDoctor) {
            setCouponDoctor(location.state.couponDoctor);
            setCouponModal(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, location.pathname, navigate]);

    const columns = [

        {
            accessorKey: 'name.firstName',
            header: 'Nombre',
            Cell: ({ renderedCellValue, row }) => (
                <>
                    {
                        row.original.img.length > 0
                            ?
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1rem',
                                }}
                            >
                                <Avatar sx={{ width: '40px', height: '40px' }} alt={renderedCellValue} src={row.original.img[0]} />
                                <Box>
                                    <span>{renderedCellValue}</span>
                                    {row.original.coupon &&
                                        <Chip
                                            size="small"
                                            color="success"
                                            variant="outlined"
                                            label={`Cupón ${row.original.coupon.name}`}
                                            sx={{ display: 'flex', mt: .5 }}
                                        />
                                    }
                                </Box>
                            </Box>
                            :
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1rem',
                                }}
                            >
                                <Avatar sx={{ bgcolor: '#2699FB', width: '40px', height: '40px', fontSize: '12px' }}>
                                    {row.original.name.firstName.charAt(0)}{row.original.name.lastName.charAt(0)}
                                </Avatar>
                                <Box>
                                    <span>{renderedCellValue}</span>
                                    {row.original.coupon &&
                                        <Chip
                                            size="small"
                                            color="success"
                                            variant="outlined"
                                            label={`Cupón ${row.original.coupon.name}`}
                                            sx={{ display: 'flex', mt: .5 }}
                                        />
                                    }
                                </Box>
                            </Box>
                    }
                </>
            ),
        },
        {
            accessorKey: 'name.lastName',
            header: 'Apellidos',
        },
        {
            accessorKey: 'email',
            enableClickToCopy: true,
            header: 'Email',
        },
        {
            accessorKey: 'speciality',
            header: 'Especialidad',
        },
        {
            accessorKey: 'phone',
            header: 'Teléfono',
        },
        {
            accessorKey: 'order_count',
            header: 'Pedidos',
        },
    ]

    //Modal editar
    const [openModal, setOpenModal] = useState(false);

    const handleClickModal = (row, closeMenu) => () => {
        const {
            name: {
                firstName,
                lastName
            },
            email, speciality, subEspecialidad, phone, cedulaProfesional,
            municipio, estado, hospital, tipoHospital, asentamiento,
            _id
        } = row;
        setActiveDoctor((e) => ({
            ...e,
            name: firstName, lastname: lastName, email, phone, ced: cedulaProfesional,
            speciality, sub_speciality: subEspecialidad, hospital, hospital_type: tipoHospital,
            _id, state: estado, mun: municipio, colony: asentamiento
        }));
        closeMenu();
        setOpenModal(true);
    };

    const openCouponModal = (doctor, closeMenu) => () => {
        closeMenu();
        if (doctor.coupon) {
            basicMsg(`Este médico ya tiene vinculado el cupón ${doctor.coupon.name}`);
            return;
        }
        setCouponDoctor(doctor);
        setCouponModal(true);
    };

    // eliminar médico
    const selectDeleteDoctor = (row, closeMenu) => async () => {
        closeMenu();
        if (await simpleConfirmDialog('¿Eliminar al médico?', 'Sí, continuar'))
            dispatch(deleteDoctor(row));
    };

    return (
        <>
            <Container maxWidth='xxl' sx={{ mb: 5 }} style={{ marginTop: '90px' }}>
                <Typography variant='h5' sx={{ mb: 4 }}>Lista de médicos</Typography>
                <Box>
                    <MaterialReactTable
                        columns={columns}
                        data={ doctors }
                        enableColumnFilterModes
                        enablePinning
                        enableRowActions
                        positionToolbarAlertBanner="bottom"
                        localization={MRT_Localization_ES}
                        renderDetailPanel={({ row }) => (
                            <Box display='flex' justifyContent='space-around' >
                                <Box>
                                    <Typography variant='body1'>
                                        <b>Cédula profesional: </b>{row.original.cedulaProfesional}
                                    </Typography>
                                    <Typography variant='body1'>
                                        <b>Sub-Especialidad: </b>{row.original.subEspecialidad}
                                    </Typography>
                                    <Typography variant='body1'>
                                        <b>Hospital: </b>{row.original.hospital}
                                    </Typography>
                                    <Typography variant='body1'>
                                        <b>Tipo de hospital: </b>{row.original.tipoHospital}
                                    </Typography>
                                </Box>
                                <Box>
                                <Typography variant='body1'>
                                    <b>Estado: </b>{row.original.estado}
                                </Typography>
                                <Typography variant='body1'>
                                    <b>Municipio: </b>{row.original.municipio}
                                </Typography>
                                <Typography variant='body1'>
                                    <b>Colonia: </b>{row.original.asentamiento}
                                </Typography>
                                </Box>
                            </Box>
                        )}
                        renderRowActionMenuItems={({ row: { original }, closeMenu }) => [
                            <MenuItem
                                key={0}
                                onClick={ handleClickModal(original, closeMenu) }
                                sx={{ m: 0 }}
                            >
                                <ListItemIcon>
                                    <EditIcon />
                                </ListItemIcon>
                                Editar
                            </MenuItem>,
                            <MenuItem
                                key={1}
                                onClick={ openCouponModal(original, closeMenu) }
                                sx={{ m: 0 }}
                            >
                                <ListItemIcon>
                                    <LocalOfferIcon />
                                </ListItemIcon>
                                Registrar cupón
                            </MenuItem>,
                            <MenuItem
                                key={2}
                                onClick={ selectDeleteDoctor(original, closeMenu) }
                                sx={{ m: 0 }}
                            >
                                <ListItemIcon>
                                    <DeleteIcon />
                                </ListItemIcon>
                                Eliminar
                            </MenuItem>,
                        ]}
                    />
                </Box>
            </Container>

            <Fab
                LinkComponent={Link}
                to='/nefro-admin/nuevo-medico'
                color="primary"
                sx={{
                    position: "fixed",
                    bottom: '35px',
                    right: '35px',
                    '&:hover': {
                        color: '#fff',
                    },
                }}
            >
                <AddIcon />
            </Fab>

            <EditDirectory
                openModal={openModal}
                setOpenModal={setOpenModal}
                activeDoctor={activeDoctor}
                setValues={setActiveDoctor}
            />
            <FullDoctorCouponModal
                open={couponModal}
                onClose={() => setCouponModal(false)}
                doctor={couponDoctor}
                onSaved={() => dispatch(loadDoctors())}
            />
        </>
    );
};

export default AdminDirectory;
